import { type PerformanceTrace, trace } from "firebase/performance";
import React from "react";
import { log } from "../ui/log";
import { perf } from "./firebaseInit";

export function usePerformance(traceName: string) {
  const t = React.useRef<PerformanceTrace>(null);

  const start = React.useCallback(() => {
    if (__DEV__) {
      log.dev("No trace start since dev", traceName);
      return;
    }

    log.dev("Trace started", traceName);
    t.current = trace(perf, traceName);
    t.current.start();
  }, [traceName]);

  const stop = React.useCallback(
    (attributes?: { [key: string]: string }) => {
      if (__DEV__) {
        log.dev("No trace stop since dev", traceName);
        return;
      }

      if (!t.current) {
        return;
      }

      if (attributes) {
        Object.keys(attributes).forEach((k) => {
          log.dev("Trace attribute", k, attributes[k]);
          t.current?.putAttribute(k, attributes[k]);
        });
      }

      t.current.stop();
      log.dev("Trace stopped", traceName);
    },
    [traceName],
  );

  return { start, stop };
}
